<!-- This file is auto-generated don't edit it! -->
<h1 id="preview">Preview</h1>
<p><ui-number-input-docs-preview></ui-number-input-docs-preview></p>
<h1 id="description">Description</h1>
<p>A input box similar to the ui-input component but the ui-number-input only allows number input.</p>
<h1 id="inputs">Inputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">id</td>
<td align="left">ID.</td>
</tr>
<tr>
<td align="left">step</td>
<td align="left">Step amount.</td>
</tr>
<tr>
<td align="left">min</td>
<td align="left">Step amount.</td>
</tr>
<tr>
<td align="left">max</td>
<td align="left">Step amount.</td>
</tr>
<tr>
<td align="left">minLabel</td>
<td align="left">When min value show this string as placeholder</td>
</tr>
<tr>
<td align="left">maxLabel</td>
<td align="left">When max value show this string as placeholder</td>
</tr>
<tr>
<td align="left">placeholder</td>
<td align="left">Placeholder text.</td>
</tr>
<tr>
<td align="left">label</td>
<td align="left">Label</td>
</tr>
<tr>
<td align="left">unitLabel</td>
<td align="left">Unit label, shown when not hovering on the component where the arrow buttons are placed</td>
</tr>
<tr>
<td align="left">btnUpDisabled</td>
<td align="left">Disable arrow button up</td>
</tr>
<tr>
<td align="left">btnDownDisabled</td>
<td align="left">Disable arrow button down</td>
</tr>
<tr>
<td align="left">arrowButtons</td>
<td align="left">Show arrow buttons to the right for incrementing/decrementing number value</td>
</tr>
<tr>
<td align="left">allowEmpty</td>
<td align="left">Should the number input be allowed to have an empty value</td>
</tr>
<tr>
<td align="left">multiplier</td>
<td align="left">Multiplier, the rendered value in the input box will be multiplied with defined multiplier. Eg. 100 for percentages.</td>
</tr>
<tr>
<td align="left">tabindex</td>
<td align="left">Tabindex</td>
</tr>
<tr>
<td align="left">autofocus</td>
<td align="left">Autofocus automatically sets focus to the input when the input component is initialized</td>
</tr>
<tr>
<td align="left">validation</td>
<td align="left">Validation</td>
</tr>
<tr>
<td align="left">format</td>
<td align="left">Number format. See <a href="https://angular.io/api/common/DecimalPipe">https://angular.io/api/common/DecimalPipe</a></td>
</tr>
<tr>
<td align="left">discrete</td>
<td align="left">Discrete mode</td>
</tr>
<tr>
<td align="left">disableUndo</td>
<td align="left">Disable native undo</td>
</tr>
<tr>
<td align="left">keyboardEmit</td>
<td align="left">Emit valueChange after user have stopped typing</td>
</tr>
<tr>
<td align="left">selectTextOnFocus</td>
<td align="left">Select all text when input gets focus</td>
</tr>
<tr>
<td align="left">onStep</td>
<td align="left">Handle step functionaliy. Notice, this won&#39;t fire submit event when set.</td>
</tr>
</tbody></table>
<h1 id="outputs">Outputs</h1>
<table>
<thead>
<tr>
<th align="left">Property</th>
<th align="left">Description</th>
</tr>
</thead>
<tbody><tr>
<td align="left">submit</td>
<td align="left">Submit event.</td>
</tr>
<tr>
<td align="left">mouseUp</td>
<td align="left">Event emitter that gets called when a mouse up event occurs on the arrow buttons.</td>
</tr>
<tr>
<td align="left">cancel</td>
<td align="left">Cancel event.</td>
</tr>
<tr>
<td align="left">_focus</td>
<td align="left">Focus event.</td>
</tr>
<tr>
<td align="left">blur</td>
<td align="left">Blur event.</td>
</tr>
<tr>
<td align="left">valueChange</td>
<td align="left">Change event.</td>
</tr>
<tr>
<td align="left">undo</td>
<td align="left">Undo event.</td>
</tr>
<tr>
<td align="left">redo</td>
<td align="left">Redo event.</td>
</tr>
</tbody></table>
